import React from "react";
import { useState } from "react";

const styles = {
  cursor: 'pointer',
  marginRight: '1rem',
  width: '200px'
};

const FileUpload = ({
  name,
  buttonStyles = {},
  chooseFileLabel = 'Choose File',
  noFileChosenLabel = 'No file chosen',
  accept = '',
  onChange = (e) => { },
  style = {},
}) => {

  const [filename, setFilename] = useState('');

  const handleChange = (e)=>{
    setFilename(e.target.files[0].name);
    onChange(e);
  };

  const layoutStyles = {display: 'flex'};

  return <div style={{...layoutStyles, ...style}}>
    <input type="file" name={name} id="actual-btn" onChange={handleChange} accept={accept} hidden />

    <label for="actual-btn" className="btn btn-primary" style={{ ...buttonStyles, ...styles }}>{chooseFileLabel}</label>

    <input id="file-chosen" type="input" className="form-control" style={{width:'100%'}} value={filename || noFileChosenLabel} />
  </div>;
};

export default FileUpload;
